import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import ModalStyle from "@/styles/components/add-interview-modal/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import Button from "@/components/button";
import "react-datetime/css/react-datetime.css";
import Tooltip from "react-simple-tooltip";
import Phone from "public/icons/call2.svg";
import Tech from "public/icons/technical.svg";
import Video from "public/icons/video.svg";
import Face from "public/icons/user.svg";
import VideoQA from "public/icons/videoqa.svg";
import { components } from "react-select";
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Autosuggest from "react-autosuggest";
import PlaceAutoComplete from "react-places-autocomplete";
import { Loading } from "@/components/loading";
import Exclamation from "public/icons/exclamation.svg";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import {
  AutocompleteError,
  Field,
  FieldArray,
  Form,
  Formik,
  FormikControl,
  useState,
  INTERVIEW_TYPES,
} from "@/imports-files/common/common";
import {
  Image,
  addManualInterview,
  manualInitialValues,
  validationManualform,
  onSuggestionSelection,
  onSuggestionsFetchRequested,
  renderInputComponent,
  renderSuggestion,
  shouldRenderSuggestions,
  InputError,
  onAutomationChange,
  handleDelete,
  initialStageValues,
  useTranslation,
  showHideButtonValue,
  AddInterviewManualAction,
  Deleteicon,
  isCustomLink,
  addMinutes,
} from "@/imports-files/pages/clients/jobs/candidate-profile-job";
import { setFilledDate } from "@/imports-files/components/job-filters";
import { CONSTANTS } from "@/imports-files/components/model/setup-video-qa";
import { VideoQaAction } from "@/actions/pages/clients/jobs/video-qa-action";
import { manageAutomationTimer, reviewAutomationEmail } from "@/actions/pages/clients/candidates/kanban";

export function AddInterviewManual({
  setBtnPopup,
  router,
  meetingData,
  setInitialData,
  action,
  job_application_id,
  setFlagForRender,
  initialData,
  from=null,
  setAddInterviewBar=null,
  restart=null,
  setTimerStatus=null,
  setUnsuccessfulEmailModal=null,
  setEmailData=null,
  setReviewKey=null

}) {
  const [addType, setAddType] = useState("range");
  const [tests, setTests] = useState([]);
  const [techStageEmail, setTechStageEmail] = useState({
    value: "",
    error: "",
  });

  const videoQaAction = new VideoQaAction(setTests);
  let interview_type = meetingData.meetingDetails?.interview_type_id
    ? meetingData.interview_types.filter(
        (x) => x.id == meetingData.meetingDetails.interview_type_id
      )[0]?.name
    : "";
  const [current_interview_type, setCurrentInterviewType] =
    useState(interview_type);
  const INITIAL_VALUES = manualInitialValues(
    meetingData?.meetingDetails,
    action || "new",
    job_application_id
  );
  INITIAL_VALUES.default_location =
    INITIAL_VALUES.children_attributes[0]?.location ||
    meetingData.default_location;
  INITIAL_VALUES.place_id =
    INITIAL_VALUES.children_attributes[0]?.place_id || meetingData.place_id;
  const { Option } = components;
  const interviewTypes = meetingData.interview_types.filter(
    (x) => x.name != INTERVIEW_TYPES.TECHTEST
  );
  const platforms = meetingData.platforms;
  const [stageEmail, setStageEmail] = useState(
    initialStageValues(INITIAL_VALUES)
  );
  const [interviewStageCount, setInterviewStageCount] = useState(
    INITIAL_VALUES.children_attributes.length
  );
  const [submitState, setSubmitState] = useState("");
  const [isLoading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const [totalDuration, setTotalDuration] = useState(
    INITIAL_VALUES.children_attributes
      .map((x) => x.duration)
      .reduce((a, b) => {
        a = parseInt(a) || 0;
        b = parseInt(b) || 0;
        return a + b;
      }, 0)
  );
  const [users, setUsers] = useState([]);
  const [sendInterview, setSendInterview] = useState(false);
  const [showHideButton, setShowHideButton] = useState(
    showHideButtonValue(INITIAL_VALUES)
  );
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const [deleteQuestionList, setDeleteQuestionList] = useState([]);
  const [disabledAddMoreQuestion, setDisabledAddMoreQuestion] = useState(false);
  const addInterviewManualAction = new AddInterviewManualAction(
    setFlagForRender,
    deleteQuestionList,
    setDeleteQuestionList,
    setDisabledAddMoreQuestion
  );
  const [languageListing, setLanguageListing] = useState(
    addInterviewManualAction.setLanguageList(
      meetingData?.meetingDetails?.language_list || meetingData?.language_list
    )
  );

  function interviewSwitchButton(type) {
    switch (type) {
      case INTERVIEW_TYPES.PHONE:
        return <Phone />;
      case INTERVIEW_TYPES.TECHTEST:
        return <Tech />;
      case INTERVIEW_TYPES.VIDEO:
        return <Video />;
      case INTERVIEW_TYPES.FACE2FACE:
        return <Face className="faceIcon" />;
      case INTERVIEW_TYPES.VIDEOQA:
        return <VideoQA />;
      default:
        return "";
    }
  }

  const IconOption = (props) => {
    return (
      <Option {...props}>
        <div className={PageStyle.Selectimg}>
          <img
            src={`${props.data.logo_url}`}
            style={{
              marginRight: 12,
              width: 20,
              height: 20,
              verticalAlign: "middle",
            }}
            alt={props.data.label}
          />
          {props.data.label}
        </div>
      </Option>
    );
  };

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal} AutomationPopup AddInterview`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => setBtnPopup({ active: false, action: "" })}
          >
            <Close/>
            CLOSE
          </div>
          <div
            className={` ${FormModalStyle.Modal__Container__ContentSection}`}
          >
            <h1
              className={` ${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              {action == "new" ? "Add" : "Edit"} Interview
            </h1>
          </div>
          <Formik
            initialValues={INITIAL_VALUES}
            validationSchema={validationManualform(
              addType,
              current_interview_type,
              sendInterview,
              platforms
            )}
            onSubmit={async (values, actions) => {
              if (submitState == "submit") {
                 if(addType == "range"){
                  setLoading(true);
                  await addManualInterview(values, router, setBtnPopup, setInitialData, setLoading, current_interview_type, setFlagForRender, setDisabledSaveButton, from);
                 }else{
                    await setAddInterviewBar({ active: true, action: {values: values, router: router, setBtnPopup: setBtnPopup, setInitialData: setInitialData, setLoading: setLoading, current_interview_type: current_interview_type, setFlagForRender: setFlagForRender, setDisabledSaveButton: setDisabledSaveButton, from: from } });
                    await setReviewKey("add_interview");
                    await setEmailData(await reviewAutomationEmail(router.query.job_id, router, { key: "add_interview", list: true}))
                    await setUnsuccessfulEmailModal({state: true})
                    await setBtnPopup({ active: false, action: "" });
                 }
                }
            }}
          >
            {(formik) => (
              <Form style={{ width: "100%" }}>
                <div
                  className={`${FormModalStyle.Modal__Container__ContentSection__FormContainer}`}
                >
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                    >
                      Type of Interview *
                    </label>
                    <div
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__IconContainer
                      }
                    >
                      {interviewTypes.map((x, interviewIndex) => {
                        return (
                          <div
                            className={
                              FormModalStyle.Modal__Container__ContentSection__Block__IconContainer__Icons
                            }
                            key={`interview_type_${interviewIndex}`}
                          >
                            <Tooltip
                              background={"#00325A"}
                              radius={50}
                              padding={11}
                              placement="top"
                              fontSize="12px"
                              content={x.name}
                              key={x.name}
                              className='SimpleTooltip'
                            >
                              <p className={PageStyle.Interview__IconsType}>
                                <input
                                  type="radio"
                                  name="interview_type_id"
                                  id={`icon${interviewIndex}`}
                                  defaultChecked={
                                    formik.values.interview_type_id == x.id
                                  }
                                  onChange={() => {
                                    formik.setFieldValue(
                                      "interview_type_id",
                                      x.id
                                    );
                                    setCurrentInterviewType(x.name);
                                    let children_attributes =
                                      formik.values.children_attributes;
                                    children_attributes.map((x) => {
                                      x._destroy = true;
                                      return x;
                                    });
                                    children_attributes.push({
                                      date: "",
                                      starttime: "",
                                      endtime: "",
                                      location:
                                        formik.values.default_location || "",
                                      place_id: formik.values.place_id || "",
                                      integration_id: "",
                                      members: [],
                                      member_ids: [],
                                      members: [],
                                      duration: "",
                                      _destroy: false,
                                    });
                                    setStageEmail(
                                      initialStageValues(formik.values)
                                    );
                                    let durations = [];
                                    setTotalDuration(
                                      durations.reduce(
                                        (a, b) =>
                                          (parseInt(a) || 0) +
                                          (parseInt(b) || 0),
                                        0
                                      )
                                    );
                                    setInterviewStageCount(1);
                                  }}
                                />
                                <label
                                  htmlFor={`icon${interviewIndex}`}
                                  className={`labelcolor`}
                                >
                                  {interviewSwitchButton(x.name)}
                                </label>
                              </p>
                            </Tooltip>
                          </div>
                        );
                      })}
                    </div>
                    <AutocompleteError
                      name={"interview_type_id"}
                      errorClass={PageStyle.Form__Error}
                      formik={formik}
                      style={InputError(formik, "interview_type_id")}
                    />
                  </div>
                  {current_interview_type == INTERVIEW_TYPES.VIDEOQA ? (
                    <div>
                      {/* ----------------- VIDEO QA Members DIV */}
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__BlockRow} mt30 `}
                      >
                        <label
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                        >
                          {t("page:clients:video-modal:texts:members")}
                        </label>
                        <div
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__InputHalf} `}
                        >
                          <Autosuggest
                            suggestions={users}
                            onSuggestionsFetchRequested={({ value }) =>
                              onSuggestionsFetchRequested(
                                value,
                                setUsers,
                                router
                              )
                            }
                            onSuggestionsClearRequested={() => setUsers([])}
                            getSuggestionValue={(suggestion) =>
                              `${suggestion.user_attributes.email}`
                            }
                            renderSuggestion={renderSuggestion}
                            renderInputComponent={
                              videoQaAction.renderMemberInputComponent
                            }
                            shouldRenderSuggestions={
                              videoQaAction.shouldRenderSuggestions
                            }
                            onSuggestionSelected={(event, { suggestion }) => {
                              if (suggestion.user_attributes.email.length > 0) {
                                setTechStageEmail({ value: "" });
                                videoQaAction.onSuggestionSelection(
                                  formik,
                                  formik.values.videoqa.member_emails,
                                  suggestion.user_attributes.email,
                                  formik.values.videoqa.member_initials,
                                  {
                                    email: suggestion.user_attributes.email,
                                    name_initials:
                                      suggestion.user_attributes.name_initials,
                                    name: suggestion.user_attributes.name,
                                  }
                                );
                                formik.validateForm();
                              }
                            }}
                            inputProps={{
                              className: `${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                              placeholder: "Start typing name or work email",
                              value: techStageEmail.value,
                              disabled: false,
                              editable: true,
                              formik: formik,
                              videoQaAction: videoQaAction,
                              add_button: false,
                              name: `videoqa.member_emails`,
                              onChange: (value, { newValue, method }) => {
                                setTechStageEmail({
                                  value: newValue,
                                  error: "",
                                });
                              },
                              setStageEmail: setTechStageEmail,
                            }}
                          ></Autosuggest>
                          <AutocompleteError
                            name={`videoqa.member_emails`}
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, `videoqa.member_emails`)}
                          />

                          <div className={`${PageStyle.Tagrow}`}>
                            {formik.values.videoqa?.member_initials?.map(
                              (item, itemIndex) => (
                                <div
                                  className={PageStyle.SetupPopup__Tags}
                                  key={`interview_email_${itemIndex}`}
                                >
                                  {item?.photo_url ? (
                                    <img
                                      src={item?.photo_url}
                                      className="JobImageSmall"
                                    />
                                  ) : (
                                    item.name_initials && (
                                      <div className={PageStyle.Tagrow__Prefix}>
                                        {item.name_initials}
                                      </div>
                                    )
                                  )}
                                  {item.name ? (
                                    <span>{item.name}</span>
                                  ) : (
                                    <span>{item.email}</span>
                                  )}
                                  <button
                                    type="button"
                                    className={PageStyle.Tagrow__Cancel}
                                    onClick={() =>
                                      videoQaAction.handleDelete(
                                        formik,
                                        itemIndex
                                      )
                                    }
                                  >
                                    <Close/>
                                  </button>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      {/* ----------------- VIDEO QA Members DIV */}

                      {/* ----------------- LANGUAGE DIV -----------------*/}
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__BlockRow} mt15`}
                      >
                        <h3
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                        >
                          {" "}
                          {CONSTANTS.texts.label1}{" "}
                        </h3>
                        <FormikControl
                          className={`${PageStyle.Form__CustomSelect}`}
                          control="select"
                          formik={formik}
                          name="language"
                          options={languageListing}
                          placeholder={"Select Language"}
                          style={InputError(formik, `language`)}
                          default={INITIAL_VALUES.language || "English"}
                          onChange={(data) => {
                            formik.setFieldValue("language", data.value);
                          }}
                        />
                      </div>
                      {/* ----------------- LANGUAGE DIV -----------------*/}

                      {/* ----------------- INTRO VIDEO DIV -----------------*/}
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__BlockRow} mt30`}
                      >
                        <div
                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer} `}
                        >
                          <h3
                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__Heading}`}
                          >
                            {CONSTANTS.texts.label2}
                          </h3>
                          <span
                            className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__SmallText}`}
                            // className={`ml0 mt5 ${PageStyle.SetupPopup__OptionalText}`}
                          >
                            {CONSTANTS.texts.optional}
                          </span>{" "}
                        </div>
                        <FormikControl
                          className={`${PageStyle.Form__Input} thresholdmodl`}
                          control="input"
                          type="text"
                          formik={formik}
                          name="video_link"
                          placeholder={CONSTANTS.texts.placeholder_intro_video}
                          style={InputError(formik, `video_link`)}
                        />
                      </div>
                      {/* ----------------- INTRO VIDEO DIV -----------------*/}

                      {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}
                      <div
                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                      >
                        {formik?.values?.questions_attributes?.map(
                          (question, index) => {
                            return (
                              <div
                                key={`question_key_${index}`}
                                className={` ${FormModalStyle.Modal__Container__ContentSection__Block__InterviewContainer}`}
                              >
                                <h4
                                  className={`${FormModalStyle.Modal__Container__ContentSection__SubHeading} ${AutomationStyle.AutomationPopup__JustifyContentBetween}`}
                                >
                                  {CONSTANTS.texts.subheading2} {index + 1}
                                  {formik.values.questions_attributes.length >
                                    1 && (
                                    <Deleteicon
                                      className={`${FormModalStyle.Modal__Container__IconSvg}`}
                                      onClick={() => {
                                        addInterviewManualAction.onDeleteClick(
                                          formik,
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </h4>
                                <div
                                  className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                                >
                                  <label
                                    className={
                                      FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                    }
                                  >
                                    {CONSTANTS.texts.label3} *
                                  </label>
                                  <FormikControl
                                    className={`${PageStyle.Form__Input} input600`}
                                    control="input"
                                    type="text"
                                    formik={formik}
                                    placeholder={
                                      CONSTANTS.texts.placeholder_question
                                    }
                                    name={`questions_attributes.${index}.question`}
                                    style={InputError(
                                      formik,
                                      `questions_attributes.${index}.question`
                                    )}
                                    onChange={(data) => {
                                      formik.setFieldValue(
                                        `questions_attributes.${index}.question`,
                                        data.target.value
                                      );
                                      formik.status &&
                                      formik.status["questions_attributes"] &&
                                      formik.status["questions_attributes"][
                                        index
                                      ] &&
                                      formik.status["questions_attributes"][
                                        index
                                      ]["question"]
                                        ? delete formik.status[
                                            "questions_attributes"
                                          ][index]["question"]
                                        : "";
                                      formik.setStatus(formik.status);
                                    }}
                                  />
                                </div>

                                <div
                                  className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                                >
                                  <label
                                    className={
                                      FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                    }
                                  >
                                    {CONSTANTS.texts.label4}
                                  </label>
                                  <FormikControl
                                    control="customtextarea"
                                    type="text"
                                    formik={formik}
                                    className={`${PageStyle.Form__Textarea} input600`}
                                    name={`questions_attributes.${index}.description`}
                                    rows="4"
                                    style={InputError(
                                      formik,
                                      `questions_attributes.${index}.description`
                                    )}
                                    placeholder={
                                      CONSTANTS.texts.placeholder_descripton
                                    }
                                  />
                                </div>
                                <div
                                  className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer}`}
                                  style={{ gridTemplateColumns: "auto auto" }}
                                >
                                  <div
                                    className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer__BlockFlex}`}
                                  >
                                    <h3
                                      className={
                                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                      }
                                    >
                                      {CONSTANTS.texts.label5} *
                                    </h3>
                                    <div>
                                      <Field
                                        component={
                                          addInterviewManualAction.NumberField
                                        }
                                        defaultValue={30}
                                        type="text"
                                        name={`questions_attributes.${index}.answer_time`}
                                        className={`${PageStyle.Form__Input} width50 inputerrorheight`}
                                        formik={formik}
                                        format={"###"}
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.answer_time`
                                        )}
                                        onValueChange={(value) => {
                                          formik.setFieldValue(
                                            `questions_attributes.${index}.answer_time`,
                                            value.floatValue
                                          );
                                          formik.status &&
                                          formik.status[
                                            "questions_attributes"
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ]["answer_time"]
                                            ? delete formik.status[
                                                "questions_attributes"
                                              ][index]["answer_time"]
                                            : "";
                                          formik.setStatus(formik.status);
                                        }}
                                      />
                                      <AutocompleteError
                                        name={`questions_attributes.${index}.answer_time`}
                                        errorClass={PageStyle.Form__Error}
                                        formik={formik}
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.answer_time`
                                        )}
                                      />
                                    </div>
                                    <h6>{CONSTANTS.texts.label6}</h6>
                                  </div>

                                  <div
                                    className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer__BlockFlex}`}
                                  >
                                    <h3
                                      className={
                                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                      }
                                    >
                                      {CONSTANTS.texts.label7} *
                                    </h3>

                                    <div>
                                      <Field
                                        component={
                                          addInterviewManualAction.NumberField
                                        }
                                        defaultValue={2}
                                        type="text"
                                        name={`questions_attributes.${index}.attempts`}
                                        className={`${PageStyle.Form__Input} width50 inputerrorheight`}
                                        formik={formik}
                                        format={"#"}
                                        onValueChange={(value) => {
                                          formik.setFieldValue(
                                            `questions_attributes.${index}.attempts`,
                                            value.floatValue
                                          );
                                          formik.status &&
                                          formik.status[
                                            "questions_attributes"
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ] &&
                                          formik.status["questions_attributes"][
                                            index
                                          ]["attempts"]
                                            ? delete formik.status[
                                                "questions_attributes"
                                              ][index]["attempts"]
                                            : "";
                                          formik.setStatus(formik.status);
                                        }}
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.attempts`
                                        )}
                                      />
                                      <AutocompleteError
                                        name={`questions_attributes.${index}.attempts`}
                                        errorClass={PageStyle.Form__Error}
                                        formik={formik}
                                        style={InputError(
                                          formik,
                                          `questions_attributes.${index}.attempts`
                                        )}
                                      />
                                    </div>
                                    <h6>{CONSTANTS.texts.label8}</h6>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                      {/* ----------------- INTERVIEW QUESTION DIV -----------------*/}

                      {/* ----------------- ADD QUESTON SECTION -----------------*/}

                      <div
                        className={`${PageStyle.SetupPopup__AddQuestion} ${PageStyle.mt15}`}
                      >
                        <Button
                          buttonstyle={
                            disabledAddMoreQuestion
                              ? `disabledbuttonlight ${ButtonStyle.primarybtn}`
                              : `${ButtonStyle.primarybtn}`
                          }
                          type="button"
                          disabled={disabledAddMoreQuestion}
                          onClick={() =>
                            addInterviewManualAction.onAddClick(formik)
                          }
                        >
                          {CONSTANTS.texts.add_question}
                        </Button>
                      </div>
                      {/* ----------------- ADD QUESTON SECTION -----------------*/}

                      {/* ----------------- CUSTOMISATION DIV ----------------- */}
                      <div
                        className={` ${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                      >
                        <h4
                          className={` ${FormModalStyle.Modal__Container__ContentSection__Block__InterviewContainer__Label}`}
                        >
                          {CONSTANTS.texts.customisations}
                        </h4>
                        <div
                          className={` ${FormModalStyle.Modal__Container__ContentSection__BlockContainer}`}
                          style={{ gridTemplateColumns: "auto auto",  marginTop: "0" }}
                        >
                          <div
                            className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer__BlockFlex}`}
                            style={{ alignItems: "center", gap: "40px" }}
                          >
                            <h3
                              className={` ${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                              style={{ margin: "0" }}
                            >
                              {CONSTANTS.texts.practice_screen}
                              <span
                                className={
                                  PageStyle.Interview__BestMatchExclamation
                                }
                                style={{ marginLeft: "10px" }}
                              >
                                <Tooltip
                                  content="Practice Screen"
                                  background={"#00325A"}
                                  radius={20}
                                  padding={8}
                                  placement="right"
                                  fontSize="12px"
                                  className='SimpleTooltip'
                                >
                                  <p className={`tooltipwidthinterview140`}>
                                    <Exclamation />
                                  </p>
                                </Tooltip>
                              </span>
                            </h3>
                            <label
                              className={PageStyle.IntegrationTable__switch}
                            >
                              <input
                                type="checkbox"
                                defaultChecked={INITIAL_VALUES.practise_screen}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    "practise_screen",
                                    event.target.checked
                                  );
                                }}
                              />
                              <span
                                className={`${PageStyle.IntegrationTable__slider} ${PageStyle.IntegrationTable__round} width40`}
                              ></span>
                            </label>
                          </div>

                          <div
                            className={`${FormModalStyle.Modal__Container__ContentSection__BlockContainer__BlockFlex}`}
                            style={{ flexDirection: "column", gap: "0" }}
                          >
                            <div
                              className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer}`}
                              style={{ flexDirection: "row", gap: "10px" }}
                            >
                              <h3
                                className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__Heading}`}
                              >
                                {CONSTANTS.texts.expires} *
                              </h3>
                              <span
                                className={`${FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__SmallText}`}
                              >
                                (in days)
                              </span>
                            </div>
                            <div>
                              <Field
                                component={addInterviewManualAction.NumberField}
                                placeholder="2"
                                type="text"
                                name="expires"
                                className={`${PageStyle.Form__Input} thresholdmodl width50`}
                                formik={formik}
                                format={"###"}
                                style={InputError(formik, `expires`)}
                                onValueChange={(value) => {
                                  formik.setFieldValue(
                                    `expires`,
                                    value.floatValue
                                  );
                                  formik.setStatus["expires"] = "";
                                }}
                              />
                              <AutocompleteError
                                name="expires"
                                errorClass={PageStyle.Form__Error}
                                formik={formik}
                                style={InputError(formik, `expires`)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* ----------------- CUSTOMISATION DIV ----------------- */}
                    </div>
                  ) : (
                    <div>
                      {current_interview_type == INTERVIEW_TYPES.FACE2FACE && (
                        <div
                          className={` ${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                        >
                          <label
                            className={` ${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                          >
                            Location *
                          </label>
                          <PlaceAutoComplete
                            value={formik.values.default_location}
                            onChange={(value) => {
                              formik.setFieldValue("default_location", value);
                              formik.setFieldValue("place_id", "");
                              formik.values.children_attributes.map((x) => {
                                x.location = value;
                                x.place_id = "";
                                return x;
                              });
                            }}
                            onSelect={(address, placeId, suggestion) => {
                              formik.setFieldValue("default_location", address);
                              formik.setFieldValue("place_id", placeId);
                              formik.values.children_attributes.map((x) => {
                                x.location = address;
                                x.place_id = placeId;
                                return x;
                              });
                            }}
                            shouldFetchSuggestions={
                              formik.values.default_location.length >= 3
                            }
                          >
                            {({
                              getInputProps,
                              getSuggestionItemProps,
                              suggestions,
                              loading,
                            }) => (
                              <div
                                className="autocomplete-root"
                                style={{ maxWidth: "50%" }}
                              >
                                <input
                                  className={PageStyle.Form__Input}
                                  name={`default_location`}
                                  placeholder={"e.g London"}
                                  style={InputError(formik, `default_location`)}
                                  {...getInputProps({})}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => (
                                    <div
                                      key={suggestion.placeId}
                                      {...getSuggestionItemProps(suggestion)}
                                    >
                                      <span key={suggestion.id}>
                                        {suggestion.description}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </PlaceAutoComplete>
                          <AutocompleteError
                            name={"default_location"}
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "default_location")}
                            custom_error_90={"custom_error_90"}
                          />
                        </div>
                      )}

                      <FieldArray
                        className={`w-auto`}
                        name="children_attributes"
                        render={(arrayHelpers) => {
                          return formik.values.children_attributes.map(
                            (item, index) => {
                              return (
                                !item._destroy && (
                                  <div
                                    key={`interview_round_${index}`}
                                    className={`${PageStyle.SetupPopup__ContentAddInterview} dnone ${AutomationStyle.AutomationPopup__FlexFlow} mt30`}
                                    style={{margin: "0"}}
                                  >
                                    {current_interview_type ==
                                      INTERVIEW_TYPES.VIDEO && (
                                      <div
                                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} wauto mt0`}>
                                        <label
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                                        >
                                          Video Platform *
                                        </label>
                                        <div style={{ width: "120px" }}>
                                          <FormikControl
                                            className={`${PageStyle.Form__CustomSelect}`}
                                            control="select"
                                            formik={formik}
                                            placeholder={"Select"}
                                            options={platforms}
                                            components={{
                                              Option: IconOption,
                                            }}
                                            onChange={(option) => {
                                              formik.setFieldValue(
                                                `children_attributes.${index}.integration_id`,
                                                option.value
                                              );
                                              if (
                                                option.label.toString() !=
                                                "Custom Link"
                                              )
                                                formik.setFieldValue(
                                                  `children_attributes.${index}.meeting_link`,
                                                  ""
                                                );
                                            }}
                                            default={
                                              formik.values.children_attributes[
                                                index
                                              ].integration_id
                                            }
                                            name={`children_attributes.${index}.integration_id`}
                                            custom_class={"form_custom_error"}
                                            style={InputError(
                                              formik,
                                              `children_attributes.${index}.integration_id`
                                            )}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className={
                                        FormModalStyle.Modal__Container__ContentSection__BlockRow
                                      }
                                      style={{
                                        gridTemplateColumns: "320px 120px",
                                      }}
                                    >
                                      <div
                                        className={
                                          `${FormModalStyle.Modal__Container__ContentSection__Block} mt0`
                                        }
                                      >
                                        <label
                                          className={
                                            FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                          }
                                        >
                                          Members *
                                        </label>
                                        <Autosuggest
                                          suggestions={users}
                                          onSuggestionsFetchRequested={({
                                            value,
                                          }) =>
                                            onSuggestionsFetchRequested(
                                              value,
                                              setUsers,
                                              router
                                            )
                                          }
                                          onSuggestionsClearRequested={() =>
                                            setUsers([])
                                          }
                                          getSuggestionValue={(suggestion) =>
                                            `${suggestion.user_attributes.email}`
                                          }
                                          renderSuggestion={renderSuggestion}
                                          renderInputComponent={
                                            renderInputComponent
                                          }
                                          shouldRenderSuggestions={
                                            shouldRenderSuggestions
                                          }
                                          onSuggestionSelected={(
                                            event,
                                            { suggestion }
                                          ) => {
                                            if (
                                              suggestion.user_attributes.email
                                                .length > 0
                                            ) {
                                              stageEmail[index] = {
                                                value: "",
                                              };
                                              setStageEmail([...stageEmail]);
                                              onSuggestionSelection(
                                                formik.values
                                                  .children_attributes[index]
                                                  .member_ids,
                                                suggestion.user_attributes.id,
                                                formik.values
                                                  .children_attributes[index]
                                                  .members,
                                                {
                                                  email:
                                                    suggestion.user_attributes
                                                      .email,
                                                  name_initials:
                                                    suggestion.user_attributes
                                                      .name_initials,
                                                  name: suggestion
                                                    .user_attributes.name,
                                                  photo_url:
                                                    suggestion.user_attributes
                                                      .photo_url,
                                                }
                                              );
                                              formik.validateForm();
                                            }
                                          }}
                                          inputProps={{
                                            className: `${PageStyle.Form__Input} width300`,
                                            placeholder:
                                              "Start typing name or work email",
                                            value: stageEmail[index].value,
                                            index: index,
                                            formik: formik,
                                            disabled: false,
                                            editable: true,
                                            name: `children_attributes.${index}.member_ids`,
                                            onChange: (
                                              value,
                                              { newValue, method }
                                            ) => {
                                              stageEmail[index] = {
                                                value: newValue,
                                              };
                                              setStageEmail([...stageEmail]);
                                            },
                                            stageEmail: stageEmail,
                                            setStageEmail: setStageEmail,
                                          }}
                                          custom_class={"form_custom_error"}
                                        ></Autosuggest>
                                        <AutocompleteError
                                          name={`children_attributes.${index}.member_ids`}
                                          errorClass={PageStyle.Form__Error}
                                          formik={formik}
                                          style={InputError(
                                            formik,
                                            `children_attributes.${index}.member_ids`
                                          )}
                                          custom_class={"form_custom_error"}
                                        />
                                        <div className={`${PageStyle.Tagrow}`}>
                                          {formik.values.children_attributes[
                                            index
                                          ].members.map((item, itemIndex) => (
                                            <div
                                              className={
                                                PageStyle.SetupPopup__Tags
                                              }
                                              key={`interview_email_${index}_${itemIndex}`}
                                            >
                                              {item?.photo_url ? (
                                                <img
                                                  src={item?.photo_url}
                                                  className="JobImageSmall"
                                                />
                                              ) : (
                                                item.name_initials && (
                                                  <div
                                                    className={
                                                      PageStyle.Tagrow__Prefix
                                                    }
                                                  >
                                                    {item.name_initials}
                                                  </div>
                                                )
                                              )}
                                              {item.name ? (
                                                <span>{item.name}</span>
                                              ) : (
                                                <span>{item.email}</span>
                                              )}
                                              <button
                                                type="button"
                                                className={
                                                  PageStyle.Tagrow__Cancel
                                                }
                                                onClick={() =>
                                                  handleDelete(
                                                    formik,
                                                    index,
                                                    itemIndex
                                                  )
                                                }
                                              >
                                                <Close/>
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          `${FormModalStyle.Modal__Container__ContentSection__Block} mt0`
                                        }
                                      >
                                        <label
                                          className={
                                            FormModalStyle.Modal__Container__ContentSection__Block__Heading
                                          }
                                        >
                                          Duration * <span>(mins)</span>{" "}
                                        </label>
                                        <FormikControl
                                          className={`${PageStyle.Form__Input}  widthhundsix`}
                                          control="input"
                                          type="text"
                                          autocomplete="off"
                                          placeholder="e g. 15"
                                          formik={formik}
                                          maxLength={3}
                                          custom_class={"form_custom_error"}
                                          name={`children_attributes.${index}.duration`}
                                          value={
                                            formik.values.children_attributes[
                                              index
                                            ].duration
                                          }
                                          onChange={(evt) => {
                                            let new_value = isNaN(
                                              evt.target.value
                                            )
                                              ? ""
                                              : parseInt(evt.target.value) == 0
                                              ? ""
                                              : evt.target.value;
                                            formik.setFieldValue(
                                              `children_attributes.${index}.duration`,
                                              new_value
                                            );
                                            let durations = [];
                                            formik.values.children_attributes.map(
                                              (x, itemIndex) => {
                                                if (!x._destroy) {
                                                  if (itemIndex == index) {
                                                    durations.push(new_value);
                                                  } else {
                                                    durations.push(
                                                      parseInt(x.duration) || 0
                                                    );
                                                  }
                                                } else {
                                                  durations.push(0);
                                                }
                                                return x;
                                              }
                                            );

                                            formik.setFieldValue(
                                              `children_attributes.${index}.endtime`,
                                              addMinutes(
                                                formik.values
                                                  .children_attributes[index]
                                                  .starttime,
                                                new_value
                                              )
                                            );

                                            durations[index] = new_value;
                                            setTotalDuration(
                                              durations.reduce(
                                                (a, b) =>
                                                  (parseInt(a) || 0) +
                                                  (parseInt(b) || 0),
                                                0
                                              )
                                            );

                                            let children_attributes =
                                              formik.values.children_attributes;
                                          }}
                                          style={InputError(
                                            formik,
                                            `children_attributes.${index}.duration`
                                          )}
                                        ></FormikControl>
                                      </div>
                                    </div>
                                    {current_interview_type ==
                                      INTERVIEW_TYPES.VIDEO && (
                                      <div
                                        className={`${FormModalStyle.Modal__Container__ContentSection__Block} width250 mt15`}
                                      >
                                        <label
                                          className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                                        >
                                          Meeting Link
                                          {isCustomLink(
                                            platforms,
                                            formik.values.children_attributes[
                                              index
                                            ].integration_id
                                          )
                                            ? ""
                                            : "*"}
                                        </label>
                                        <FormikControl
                                          className={`${PageStyle.Form__Input}  width250`}
                                          control="input"
                                          type="text"
                                          autocomplete="off"
                                          placeholder=""
                                          formik={formik}
                                          name={`children_attributes.${index}.meeting_link`}
                                          value={
                                            formik.values.children_attributes[
                                              index
                                            ].meeting_link
                                          }
                                          style={InputError(
                                            formik,
                                            `children_attributes.${index}.meeting_link`
                                          )}
                                          disabled={isCustomLink(
                                            platforms,
                                            formik.values.children_attributes[
                                              index
                                            ].integration_id
                                          )}
                                          custom_class={"form_custom_error"}
                                        />
                                      </div>
                                    )}
                                    <div
                                      className={` ${PageStyle.crossimgheight} ${AutomationStyle.AutomationPopup__DeleteIcon}`}
                                    >
                                      {interviewStageCount != 1 && (
                                        <img
                                          src="/icons/close.png"
                                          alt=""
                                          className={`mt50`}
                                          onClick={() =>
                                            onAutomationChange(
                                              formik,
                                              "remove",
                                              index,
                                              setStageEmail,
                                              setInterviewStageCount,
                                              setTotalDuration,
                                              current_interview_type,
                                              setShowHideButton
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                )
                              );
                            }
                          );
                        }}
                      ></FieldArray>
                      {formik.values.interview_type_id &&
                        current_interview_type != INTERVIEW_TYPES.PHONE && (
                          <div
                            className={`dnone ${PageStyle.addbtnposition} mt25 mb45`}
                          >
                            <div>
                              {formik.values.interview_type_id &&
                                current_interview_type !=
                                  INTERVIEW_TYPES.PHONE &&
                                showHideButton && (
                                  <Button
                                    buttonstyle={`${ButtonStyle.primarybtn}`}
                                    type="button"
                                    onClick={() => {
                                      onAutomationChange(
                                        formik,
                                        "add",
                                        undefined,
                                        setStageEmail,
                                        setInterviewStageCount,
                                        setTotalDuration,
                                        current_interview_type,
                                        setShowHideButton
                                      );
                                    }}
                                  >
                                    Add Interview
                                  </Button>
                                )}
                            </div>
                          </div>
                        )}
                      {current_interview_type != "" && (
                        <div className={"mt30"}>
                          <div className="d-flex justify-content-between align-items-center mt20">
                            <div className={`WrapperRadio w100`}>
                              <label
                                className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}
                              >
                                <Field
                                  type="radio"
                                  name="date_range"
                                  id="option-1"
                                  value={true}
                                  onChange={(event) => {
                                    formik.setFieldValue("date_range", true);
                                    let children_attributes =
                                      formik.values.children_attributes;
                                    children_attributes.map((x) => {
                                      x.start_time = "";
                                      x.end_time = "";
                                      return x;
                                    });
                                    setAddType("range");
                                  }}
                                />
                                <span
                                  style={{ marginTop: "2px" }}
                                  className="WrapperRadiocheckmark"
                                ></span>{" "}
                                <span className={`ml5 mt-0`}>
                                  Send availability for candidate to select
                                </span>
                              </label>
                              <label
                                className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}
                              >
                                <Field
                                  type="radio"
                                  name="date_range"
                                  id="option-2"
                                  value={false}
                                  onChange={(event) => {
                                    formik.setFieldValue("date_range", false);
                                    let children_attributes =
                                      formik.values.children_attributes;
                                    children_attributes.map((x) => {
                                      x.start_time = "";
                                      x.end_time = "";
                                      return x;
                                    });
                                    setAddType("time");
                                  }}
                                />
                                <span
                                  style={{ marginTop: "2px" }}
                                  className="WrapperRadiocheckmark"
                                ></span>{" "}
                                <span className={`ml5`}>Select date time</span>
                              </label>
                            </div>
                          </div>
                          {addType == "range" && (
                            <div className="heightauto"></div>
                          )}

                          {!formik.values.date_range && (
                            <FieldArray
                              name="children_attributes"
                              render={(arrayHelpers) => {
                                return formik.values.children_attributes.map(
                                  (item, index) => {
                                    return (
                                      !item._destroy && (
                                        <div
                                          className={`${PageStyle.SetupPopup__ContentAddInterview} ${ModalStyle.AddInterview__ContentAddInterview}`}
                                          key={`interview_round_${index}`}
                                        >
                                          <div
                                            className={`${PageStyle.SetupPopup__ContentFlex} width145`}
                                          >
                                            <label>Interview Date *</label>
                                            <FormikControl
                                              control="customKeyboardPicker"
                                              className={"JobCustomDateTime"}
                                              format={"DD/MM/YYYY"}
                                              inputProps={{
                                                readOnly: false,
                                                style: InputError(
                                                  formik,
                                                  `children_attributes.${index}.date`
                                                ),
                                              }}
                                              minDate={
                                                new Date(
                                                  new Date().setDate(
                                                    new Date().getDate()
                                                  )
                                                )
                                              }
                                              minDateMessage={`Interview date must be present or future date`}
                                              disablePast={true}
                                              placeholder="dd/mm/yyyy"
                                              name={`children_attributes.${index}.date`}
                                              onChange={async (date) => {
                                                await formik.setFieldValue(
                                                  `children_attributes.${index}.date`,
                                                  date.format("DD/MM/YYYY")
                                                );
                                              }}
                                              formik={formik}
                                              custom_class={"form_custom_error"}
                                              value={
                                                typeof formik.values
                                                  .children_attributes[index]
                                                  .date == "string"
                                                  ? setFilledDate(
                                                      formik.values
                                                        .children_attributes[
                                                        index
                                                      ].date
                                                    )
                                                  : formik.values
                                                      .children_attributes[
                                                      index
                                                    ].date
                                              }
                                            />
                                          </div>
                                          <div
                                            className={`${PageStyle.SetupPopup__ContentFlex} Timebg`}
                                          >
                                            <label>Start Time *</label>
                                            <FormikControl
                                              control={"timeinput"}
                                              disabled={false}
                                              value={
                                                formik.values
                                                  .children_attributes[index]
                                                  .starttime
                                              }
                                              fullTimeDropdown={true}
                                              allowDelete={true}
                                              hour12Format={false}
                                              onChange={(dateString) => {
                                                formik.setFieldValue(
                                                  `children_attributes.${index}.starttime`,
                                                  dateString
                                                );
                                                formik.setFieldValue(
                                                  `children_attributes.${index}.endtime`,
                                                  addMinutes(
                                                    dateString,
                                                    formik.values
                                                      .children_attributes[
                                                      index
                                                    ].duration
                                                  )
                                                );
                                              }}
                                              inputProps={{
                                                style: InputError(
                                                  formik,
                                                  `children_attributes.${index}.starttime`
                                                ),
                                              }}
                                              errorClass={PageStyle.Form__Error}
                                              name={`children_attributes.${index}.starttime`}
                                              formik={formik}
                                              custom_class={"form_custom_error"}
                                              manuallyDisplayDropdown={true}
                                            />
                                          </div>{" "}
                                          <div
                                            className={`${PageStyle.SetupPopup__ContentFlex} Timebg`}
                                          >
                                            <label>End Time *</label>
                                            <FormikControl
                                              control={"timeinput"}
                                              disabled={true}
                                              value={
                                                formik.values
                                                  .children_attributes[index]
                                                  .endtime
                                              }
                                              fullTimeDropdown={false}
                                              allowDelete={true}
                                              hour12Format={false}
                                              onChange={(dateString) => {
                                                formik.setFieldValue(
                                                  `children_attributes.${index}.endtime`,
                                                  dateString
                                                );
                                              }}
                                              inputProps={{
                                                style: InputError(
                                                  formik,
                                                  `children_attributes.${index}.endtime`
                                                ),
                                              }}
                                              errorClass={PageStyle.Form__Error}
                                              name={`children_attributes.${index}.endtime`}
                                              formik={formik}
                                              custom_class={"form_custom_error"}
                                              manuallyDisplayDropdown={true}
                                            />
                                          </div>
                                        </div>
                                      )
                                    );
                                  }
                                );
                              }}
                            ></FieldArray>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {addType == "time" && <div className="heightauto"></div>}
                  {formik.values.interview_type_id &&
                      current_interview_type !=
                        INTERVIEW_TYPES.VIDEOQA && (
                        <div className="w100">
                          {formik.values.interview_type_id && (
                            <div
                              className={`${PageStyle.SetupPopup__Duration} ${AutomationStyle.AutomationPopup__TotalDuration} m0 mt30`}
                            >
                              <h3>Total Duration</h3>
                              <span>
                                {totalDuration}{" "}
                                {t(
                                  "page:clients:video-modal:texts:minutes"
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={`${ButtonStyle.primarybtn}`}
                      type="button"
                      disabled={disabledSaveButton}
                      onClick={async () => {
                        setSendInterview(true);
                        await setSubmitState("submit");
                        formik.submitForm();
                      }}
                    >
                     {[INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type) && addType == "time" ? 'review email and send' : 'Send' }
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
}
